import { Flex } from '@approvalmax/ui/src/components';
import { LineItemsTable } from 'pages/requestForm/components/lineItemsSection/LineItemsTable/LineItemsTable';
import styled from 'styled-components';

export const SectionHeader = styled(Flex)`
    padding: 0 60px;
    position: relative;
`;

export const DropdownEditorContainer = styled.div`
    margin: -3px;
`;

export const JournalEntryLinesTable = styled(LineItemsTable)`
    overflow: auto;

    & .reqf-line-items-table-row__row-body {
        overflow: initial;
    }

    & .reqf-line-items-table__add-line-button:hover {
        border-color: transparent;
    }
`;
